// extracted by mini-css-extract-plugin
module.exports = {"loadingText":"Loader_loadingText__1QmW7","loading-text":"Loader_loading-text__2jd-9"};